module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "copyright",
    attrs: {
      "id": "cop"
    }
  }, [_c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/9780312602765_L03.png"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center2"
  }, [_c('span', {
    staticClass: "small"
  }, [_c('strong', [_vm._v("SQUARE")])])]), _vm._v(" "), _c('p', {
    staticClass: "center3"
  }, [_c('span', {
    staticClass: "small"
  }, [_c('strong', [_vm._v("FISH")])])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("An Imprint of Macmillan")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("SIDE EFFECTS")]), _vm._v(". Copyright © 2006 by Amy Goldman Koss. All rights reserved."), _c('br'), _vm._v("Distributed in Canada by H.B. Fenn and Company Ltd. Printed in March 2010"), _c('br'), _vm._v("in the United States of America by R. R. Donnelley & Sons Company,"), _c('br'), _vm._v("Harrisonburg, Virginia. For information, address Square Fish,"), _c('br'), _vm._v("175 Fifth Avenue, New York, NY 10010.")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Square Fish and the Square Fish logo are trademarks of Macmillan and are used by Roaring Brook Press under license from Macmillan.")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Library of Congress Cataloging-in-Publication Data"), _c('br'), _vm._v("Koss, Amy Goldman"), _c('br'), _vm._v("Side effects / Amy Goldman Koss."), _c('br'), _vm._v("p. cm."), _c('br'), _vm._v("“A Deborah Brodie Book.”"), _c('br'), _vm._v("Summary: Everything changes for Isabelle, not quite fifteen,"), _c('br'), _vm._v("when she is diagnosed with lymphoma—but eventually she"), _c('br'), _vm._v("survives and even thrives."), _c('br'), _vm._v("ISBN: 978-0-312-60276-5"), _c('br'), _vm._v("[1. Cancer—Fiction. 2. Chemotherapy—Fiction."), _c('br'), _vm._v("3. Family problems—Fiction.] I. Title."), _c('br'), _vm._v("PZ7.K8527Sid    2006    [Fic]—dc22"), _c('br'), _vm._v("2005     031473")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Originally published in the United States by Deborah Brodie Books,"), _c('br'), _vm._v("an imprint of Roaring Brook Press"), _c('br'), _vm._v("Square Fish logo designed by Filomena Tuosto"), _c('br'), _vm._v("Book design by Robin Hoffman / Brand X Studios"), _c('br'), _vm._v("First Square Fish Edition: 2010"), _c('br'), _vm._v("10  9  8  7  6  5  4  3  2  1"), _c('br'), _c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "http://www.squarefishbooks.com",
      "target": "_blank"
    }
  }, [_vm._v("www.squarefishbooks.com")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d5207e70","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/9780312602765_epub_cop_r1.vue
// module id = 60
// module chunks = 0